<template>
    <font-awesome-icon :icon="['fas', icon]"></font-awesome-icon>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faArrowLeft,
    faArrowRight,
    faCheck,
    faChevronDown,
    faChevronUp,
    faClipboardCheck,
    faEllipsisV,
    faExclamationCircle,
    faExclamationTriangle,
    faFilter,
    faFolderOpen,
    faList,
    faPlug,
    faSearch,
    faServer,
    faSmile,
    faSmileWink,
    faUsers,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";

export default {
    name: "FaIcon",
    components: {
        FontAwesomeIcon,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
    },
    setup() {
        library.add(
            faSmile,
            faSmileWink,
            faArrowLeft,
            faArrowRight,
            faServer,
            faList,
            faEllipsisV,
            faFolderOpen,
            faUsers,
            faClipboardCheck,
            faExclamationTriangle,
            faExclamationCircle,
            faPlug,
            faSearch,
            faCheck,
            faChevronDown,
            faChevronUp,
            faSearch,
            faChevronUp,
            faChevronDown,
            faFilter,
            faTrash
        );
    },
};
</script>
